import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { deserialize } from '@shared/models/base-helper';
import { Faq } from '@shared/models/faq.model';

interface DeserializedResponse {
  results: Faq[];
  total: number;
}

interface QueryResponse {
  results: any[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  apiUrl = environment.apiUrl + '/faqs/';

  constructor(readonly http: HttpClient) {}

  getFilteredFaqs: (filterString: string) => Observable<DeserializedResponse> = (filterString) => {
    const filterUrl = this.apiUrl + filterString;

    return this.http.get<QueryResponse>(filterUrl).pipe(
      map(response => {
        const deserializedResponse: DeserializedResponse = {
          results: [],
          total: response.total,
        };
        for (const serializedFaq of response.results) {
          deserializedResponse.results.push(deserialize(serializedFaq, Faq));
        }
        return deserializedResponse;
      })
    );
  }

  getFaqById(id: number): Observable<Faq> {
    return this.http.get<any>(`${this.apiUrl}${id}/`)
      .pipe(map(group => (group ? deserialize(group, Faq) : null)));
  }

  getFaqsByPage(pageName: string): Observable<Faq[]> {
    return this.http.get<any[]>(`${this.apiUrl}page_name/${pageName}/`).pipe(
      map(results => results.map((faq: any) => deserialize(faq, Faq))),
    );
  }

  createNew(faq: any) {
    return this.http.post<any>(this.apiUrl, faq).pipe(map((response: any) => deserialize(response, Faq)));
  }

  update(faqId: number, faq: any) {
    return this.http.put<any>(`${this.apiUrl}${faqId}/`, faq).pipe(
      map((response: any) => deserialize(response, Faq)),
    );
  }

  delete(id: number) {
    return this.http.delete(`${this.apiUrl}${id}/`).pipe(
      map((response: any) => deserialize(response, Faq)),
    );
  }
}
